import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * Permet d'afficher sur la page Home des statistiques sur les équipements
 * @param {array} data - données à traiter
 * @param {array} percentage - tableau de chaque partie de la ligne (objet {percentage, color, value})
 * @param {string} type - pour rediriger vers la bonne page et afficher le titre approprié
 */

export default function HomeLine({ data, percentage, type }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const totalPercentage = percentage.reduce((acc, item) => acc + item.percentage, 0);
  const adjustedPercentages = percentage.map(item => ({
    ...item,
    percentage: (item.percentage / totalPercentage) * 100
  }));

  return (
    <>
      {percentage.length > 0 && (
        <div className="homeline" onClick={() => navigate(`/${type}`)}>
          <h2>
            <span>
              {data.length}{" "}
              {type !== "webex"
                ? t("équipements")
                : t("équipements collaboration")}
            </span>
          </h2>
          <div className="homeline-item_bar">
            {percentage.map((item) => {
              return (
                item.percentage > 0 && (
                  <div
                    key={item.value}
                    className="homeline-item_bar-container"
                    style={{
                      width: (item.percentage * 100) / data.length + "%",
                      backgroundColor: item.color,
                    }}
                  >
                  </div>
                )
              );
            })}
          </div>
          <div className="homeline-legend">
            {percentage.map((item, index) => {
              return (
                item.percentage > 0 && (
                  <div className="homeline-legend_item" key={item.value}>
                    <span
                      className="homeline-legend_round"
                      style={{ backgroundColor: item.color }}
                    ></span>
                    <div className="homeline-legend_item-content">
                      <span>
                        {" "}
                        {t(item.value)}
                      </span>
                      <div  className="homeline-legend_text">
                        <span className="homeline-item_value">
                          {item.percentage}
                        </span>
                        <span>
                          ({Math.round(adjustedPercentages[index].percentage.toFixed(2))}%)
                        </span>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
